import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=d7964e96&scoped=true"
var script = {}
import style0 from "./Support.vue?vue&type=style&index=0&id=d7964e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7964e96",
  null
  
)

export default component.exports